import {MunshiMenu} from "../components/Menu";
import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import Navbar from "react-bootstrap/Navbar";
import {getLevelName} from "../utilities/Authanticate";
import CsvUpload from "../components/Worker/Upload";
import {Calendar} from "primereact/calendar";
import {WorkerComponent} from "../components/Worker/WorkerComponent";
import {axiosInstance} from "../utilities/AxiosConfig";
import {notify} from "../components/toast";
import {AttendanceMonthlyPrint, AttendancePrint, AttendanceReportPrint} from "../print/AttendancePrint";
import {sF} from "../utilities/NumberFormatter";
import {useSpinner} from "../context/SpinnerContext";
import {ToastContainer} from "react-toastify";
import {Auths} from "../utilities/getAuthDep";


const WorkerReport = ({handle}) => {
    const [user, setUser] = useState();
    const [level] = useState(Auths);
    const [database, setDatabase] = useState();
    const [workerList, setWorkerList] = useState([])
    const [worker, setWorker] = useState({id: 0, name: ""})
    const [month, setMonth] = useState(new Date());
    const [ph, setPh] = useState(0);
    const {loading, setLoading} = useSpinner()
    const [companyName, setCompanyName] = useState("");
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`biodata/`,).then((response) => {
            setCompanyName(response.data.name)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, []);
    useEffect(() => {
        setLoading(true)

        setUser(Cookies.get('user'));
        setDatabase(Cookies.get('database') || "Test");
        setLoading(false)
    }, [])
    const handleReport = () => {
        if (worker) {
            if (worker.name === "ALL") {
                if (month.getFullYear() === 2000) {
                    axiosInstance.get(`/attendance/`).then((response) => {
                        AttendancePrint(response.data.map((it) => {
                            return {
                                ...it
                            }
                        }), companyName)
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        setLoading(false)
                    )
                } else {
                    axiosInstance.get(`/attendance/month/${month.getMonth() + 1}&${ph}`).then((response) => {
                        AttendanceMonthlyPrint(response.data.map((it) => {
                            return {
                                ...it
                            }
                        }), companyName)
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        setLoading(false)
                    )
                }
            } else {
                if (worker.id !== 0 && month.getFullYear() !== 2000) {
                    axiosInstance.get(`/attendance/report/${month.getMonth() + 1}&${worker.id}&${ph}`).then((response) => {
                        AttendanceReportPrint(response.data.map((it) => {
                            return {
                                ...it
                            }
                        }), companyName)
                    }).catch((error) => {
                        notify(error.message, "error")
                    })
                }
            }

        }
    }
    useEffect(() => {
        setLoading(true)
        axiosInstance.get("/worker/").then((response) => {
            setWorkerList(response.data.map((worker) => {
                return {
                    id: worker.id,
                    name: `${worker.firstName},${worker.lastName}`
                }
            }))
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])

    if (!loading && workerList.length > 0) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                <div className="mt-7">
                    <WorkerComponent worker={worker} setWorker={setWorker} workerList={workerList} month={month}
                                     setMonth={setMonth}
                                     ph={ph} setPh={setPh} handleReport={handleReport} loading={loading}
                                     setLoading={setLoading}/>/>
                </div>
            </>
        );
    }
};


export default WorkerReport;